'use client'

import { useEffect, useState } from 'react'

export type TurnstileClientConfig = { mode: 'off' | 'log' | 'enforce'; siteKey: string | null }

// One fetch per page load, shared by every widget on the page.
let configPromise: Promise<TurnstileClientConfig> | null = null

export function loadTurnstileConfig(): Promise<TurnstileClientConfig> {
  if (!configPromise) {
    configPromise = fetch('/api/security/turnstile', { cache: 'no-store' })
      .then((r) => (r.ok ? r.json() : { mode: 'off', siteKey: null }))
      .then((d) => ({ mode: d?.mode ?? 'off', siteKey: typeof d?.siteKey === 'string' && d.siteKey ? d.siteKey : null }))
      // Fail open: no config means no widget, and the server's fallback applies.
      .catch(() => ({ mode: 'off' as const, siteKey: null }))
  }
  return configPromise
}

/** undefined while loading, then the config. */
export function useTurnstileConfig(): TurnstileClientConfig | undefined {
  const [config, setConfig] = useState<TurnstileClientConfig | undefined>(undefined)
  useEffect(() => {
    let alive = true
    loadTurnstileConfig().then((c) => { if (alive) setConfig(c) })
    return () => { alive = false }
  }, [])
  return config
}
